import { memo } from 'react';
import * as React from 'react';
import { useApplicationStore } from 'modules/application/store';

interface Props {
  children: React.ReactNode;
}

const VisibleWithMouse = ({ children }: Props) => {
  const isTouchDevice = useApplicationStore((state) => state.isTouchDevice);

  if (isTouchDevice) {
    return null;
  }

  return children;
};

const MemoizedVisibleWithMouse = memo(VisibleWithMouse);

export default MemoizedVisibleWithMouse;
